import { Router } from '@angular/router';
import { SuperService } from './../services/super.service';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize } from 'rxjs/operators';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpErrorResponse,
} from '@angular/common/http';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(
		private authService: AuthService,
		private toastr: ToastrService,
		private router: Router
	) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		// Assert user is logged in

		if (this.authService.isAuthenticated) {
			const accessToken = this.authService.accessToken;
			const idToken = this.authService.idToken;

			if (
				!request.url.includes('locationiq') &&
				!request.url.includes('google') &&
				!request.url.includes(
					'https://nina-complaints-api-media-stage.s3.amazonaws.com/'
				) &&
				!request.url.includes('list-bus-lines') &&
				!request.url.includes('refresh') &&
				!request.url.includes('logout')
			) {
				if (
					Boolean(localStorage.getItem('superUser')) &&
					!request.url.includes(environment.backend.complaintsURL)
				) {
					request = request.clone({
						setHeaders: {
							'nina-secret': '0rangotang0Azul',
							Authorization: idToken,
							'access-token': accessToken,
						},
					});
				} else {
					request = request.clone({
						setHeaders: {
							Authorization: idToken,
							'access-token': accessToken,
						},
					});
				}
			} else if (request.url.includes('logout')) {
				request = request.clone({
					setHeaders: {
						'access-token': accessToken,
					},
				});
			}
		}

		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error.status === 401) {
					this.handle401Error(request, next);
				} else if (error.status === 403) {
					this.toastr.error('Você não tem autorização para fazer isso.');
				} else if (error.status === 404) {
					this.toastr.error('Não encontramos o que você está procurando.');
				} else if (error.status === 500) {
					this.toastr.error('Ocorreu um erro interno no servidor.');
				} else {
					this.toastr.error('Ocorreu um erro inesperado.');
					return throwError(error);
				}
			}),
			finalize(() => {})
		);
	}

	private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
		if (!request.url.includes('login')) {
			// TODO: Lidar com o erro 401
			// * Tratar casos que o erro ocorra casualmente e casos que o token tenha expirado
			// localStorage.clear();
			// this.router.navigate(['auth']);
		} else {
			this.toastr.error('Login e Senha incorretos. Tente novamente.');
			this.authService.logout();
		}
	}
}
